import { render, staticRenderFns } from "./salary-register-pdf.vue?vue&type=template&id=48ddc84f&"
import script from "./salary-register-pdf.vue?vue&type=script&lang=js&"
export * from "./salary-register-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports